import type { RouteRecordRaw } from 'vue-router';

import { WebLocale } from '@/enums/web-locale';
import { PageType } from '@/routing/config';
import { CollectionType } from '@/enums/collection-type';
import { JWTV_LAUNCH_COUNTRIES } from '@/features/jwtv/config';

export function makeRentalListRoutes(currentLocale: WebLocale): RouteRecordRaw[] {
	const routes: RouteRecordRaw[] = [];

	if (JWTV_LAUNCH_COUNTRIES.includes(currentLocale)) {
		routes.push(makeJwtvLPRoute(currentLocale as WebLocale));
	}

	return routes;
}

function makeJwtvLPRoute(currentLocale: WebLocale): RouteRecordRaw {
	return {
		name: 'app.jwtv.landing-page',
		path: `/${currentLocale}/justwatch-tv`,
		component: () => import('@/pages/landing-pages/jwtv/JWTVLP.vue'),
		meta: {
			tab: 'watch',
			pageType: PageType.WATCH,
			collectionType: CollectionType.JWTV_WATCH_PAGE,
		},
	};
}
